;(function () {
  var usages = 0
  var openingTimer
  var ANIMATION_DURATION = 250 // matches $modal--animation-duration
  var bodyClassList = document.querySelector("body").classList
  var OVERLAY_OPENED_CLASS = "overlay-opened"
  var NOSCROLL_CLASS = "noscroll"

  function beforeMount() {
    if (usages === 0) {
      bodyClassList.add(NOSCROLL_CLASS)
      openingTimer = setTimeout(function () {
        bodyClassList.add(OVERLAY_OPENED_CLASS)
      }, ANIMATION_DURATION)
    }
    usages++
  }

  function beforeUnmount() {
    if (usages === 1) {
      clearTimeout(openingTimer)
      bodyClassList.remove(NOSCROLL_CLASS)
      bodyClassList.remove(OVERLAY_OPENED_CLASS)
    }
    usages--
  }

  window.HB = window.HB || {}
  window.HB.fullscreenOverlay = {
    beforeMount: beforeMount,
    beforeUnmount: beforeUnmount,
  }
})()
